// extracted by mini-css-extract-plugin
export default {"crd":"StatCard_crd__3QOZq","icon":"StatCard_icon__dpddj","link":"StatCard_link__eGsE4","title":"StatCard_title__gHlIE","count":"StatCard_count__Lh2kx"};